import { Box } from '@mui/joy';

import { SubtitleCard } from 'core/components/SubtitleCards/SubtitleCard';
import { Loader } from 'core/elements';
import { InventoryHelper } from 'core/helpers';
import { Level, Size } from 'theme/enums';

interface IProps {
  groupName: string;
  vendorName?: string;
  total?: number | null;
  uom?: string;
  computeHint?: string;
  loading?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

const wrapperSx = {
  width: 240,
  flex: 'none',
  cursor: 'pointer',
  display: 'flex',
  border: 'none',
  padding: 0,
  background: 'transparent',
  textAlign: 'inherit',
  font: 'inherit',
  color: 'inherit',
};

const cardBaseSx = { width: '100%', flex: 'none' };
const cardSelectedSx = {
  ...cardBaseSx,
  backgroundColor: 'primary.softBg',
};

const hintValueProps = {
  level: Level.BODY_XS,
  sx: { fontStyle: 'italic', fontWeight: 600 },
};

const loaderSx = { width: 'auto', margin: 0 };

const loaderElement = <Loader size={Size.SM} style={loaderSx} />;

const formatTotal = (total?: number | null, uom?: string) =>
  InventoryHelper.getInventoryAvailabilityLabel(total, uom);

export const VendorInventoryCard = ({
  groupName,
  vendorName,
  total,
  uom,
  computeHint,
  loading,
  selected,
  onClick,
}: IProps) => {
  const showHint = !loading && total == null && !!computeHint;
  const value = showHint ? computeHint : formatTotal(total, uom);

  return (
    <Box component="button" type="button" onClick={onClick} aria-pressed={selected} sx={wrapperSx}>
      <SubtitleCard
        label={groupName}
        subtitle={vendorName}
        value={value}
        options={{
          cardSx: selected ? cardSelectedSx : cardBaseSx,
          contentSx: { justifyContent: 'space-between' },
          labelProps: { level: Level.TITLE_MD, color: null },
          valueProps: showHint ? hintValueProps : undefined,
          valueElement: loading ? loaderElement : undefined,
        }}
      />
    </Box>
  );
};
